import { ACTIONS } from 'actions/start-speed-test';

const initialState = {
  isStartSpeedTest: null,
};

export default function defaultExport(state = initialState, { type }) {
  switch (type) {
    case ACTIONS.SET_START_SPEED_TEST:
      return {
        ...state,
        isStartSpeedTest: true,
      };
    case ACTIONS.CLEAR_START_SPEED_TEST:
      return initialState;

    default:
      return state;
  }
}
